import { Http } from '@angular/http';
import { API } from './../api/services/api.service';
import { Component, OnInit, Input, Output } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { UserService, SongsService } from '../api/';
import { Globals } from '../app.globals';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
  selector: 'app-invite-friends',
  templateUrl: './invite-friends.component.html',
  styleUrls: ['./invite-friends.component.css']
})
export class InviteFriendsComponent implements OnInit {
  @Input() shareArtist: any;
  @Input() song: any;
  @Input() playlist: any;
  dialogRef: MdDialogRef<InviteFriendsDialog>;
  @BlockUI() blockUI: NgBlockUI;
  constructor(public dialog: MdDialog, private api: API, private http: Http) { }

  openDialog(event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.shareArtist) {
      this.dialogRef = this.dialog.open(InviteFriendsDialog, {
        disableClose: false,
        // width: '600px',
        height: '260px'
      });
      this.dialogRef.componentInstance.title = "Copy the code below to share with your friends";
      this.dialogRef.componentInstance.artistUrl = this.shareArtist.slug;
      // to create a page for share url of Artist
      let user_id=   (localStorage.getItem('user_id')!=null) ? "/"+localStorage.getItem('user_id')+"" : '/0';
      this.api.get('songs/share-url?slug=' + this.shareArtist.slug + '&category=artist&id=' + user_id ).subscribe( res => {
        console.log(res);
      })
    } else if (this.song) {
      this.dialogRef = this.dialog.open(InviteFriendsDialog, {
        disableClose: false,
        // width: '600px',
        height: '260px'
      });
      this.dialogRef.componentInstance.title = "Copy the code below to share with your friends";
      this.dialogRef.componentInstance.songUrl = this.song.slug;
      // to create a page for share url
      let user_id=   (localStorage.getItem('user_id')!=null) ? "/"+localStorage.getItem('user_id')+"" : '/0';
      this.api.get('songs/share-url?slug=' + this.song.slug + '&category=song&id=' +  user_id).subscribe(res=>{
        console.log(res);
      });
    } else if (this.playlist) {
      this.dialogRef = this.dialog.open(InviteFriendsDialog, {
        disableClose: false,
        // width: '600px',
        height: '260px'
      });
      this.dialogRef.componentInstance.title = "Copy the code below to share with your friends";
      if (this.playlist.type == "R") {
        this.dialogRef.componentInstance.radioUrl = this.playlist.slug;
      } else {
        this.dialogRef.componentInstance.playlistUrl = this.playlist.slug;
      }
      // to create a page for share url
      let user_id=   (localStorage.getItem('user_id')!=null) ? "/"+localStorage.getItem('user_id')+"" : '/0';
      this.api.get('songs/share-url?slug=' + this.playlist.slug + '&category=playlist&id=' +  user_id).subscribe(res=>{
        console.log(res);
      });
    }
    else {
      this.dialogRef = this.dialog.open(InviteFriendsDialog, {
        disableClose: false,
        width: '600px',
        height: '185px'
      });
      this.dialogRef.componentInstance.title = "Invite your friends and earn credits";

    }
  }

  ngOnInit() {
  }

}


@Component({
  selector: 'dialog-invite-friends-dialog',
  templateUrl: 'dialog-invite-friends-dialog.html',
  styleUrls: ['./dialog-invite-friends-dialog.css']
})

export class InviteFriendsDialog implements OnInit {
  public shareUrl: string = null;
  public shareUrl2: string = null;
  public iframeUrl: string = null;
  public songUrl: string = null;
  public playlistUrl: string = null;
  public radioUrl: string = null;
  public artistUrl: string = null;
  public title: string = '';
  private embedcodeCheck: boolean = false;
  public onlineOffline1: boolean = navigator.onLine;

  constructor(public dialogRef: MdDialogRef<InviteFriendsDialog>, private userService: UserService) {
    window.addEventListener('online', () => {this.onlineOffline1 = true; });
    window.addEventListener('offline', () => {this.onlineOffline1 = false});
  }

  ngOnInit() {
    this.shareUrl2 = null;
    if(this.onlineOffline1) {
      this.userService.getReferralCode().subscribe((code) => {
        let user_id=   (localStorage.getItem('user_id')!=null) ? "/"+localStorage.getItem('user_id')+"" : '/0';
        if (this.playlistUrl) {
        // changing the iframe url for playlist to url.com/P/0/playlist-slug
          this.iframeUrl = new Globals().shareUrl + '/P'+user_id+'/' + this.playlistUrl + '?share=true';
          // changing the url for share url purpose
          this.shareUrl = new Globals().shareUrl + '/playlist/' + this.playlistUrl + '.html';
          this.shareUrl2 = "<" + "iframe " + "style" + "=" + '"position: relative; width: 100%; min-height: 450px;height:100vh"'  +  " src" + "=" + '"' + this.iframeUrl + '"' + ">" +  " </iframe>";
        } else if (this.artistUrl) {
          // changing the iframe url for artist to url.com/A/0/artist-slug
          this.iframeUrl = new Globals().shareUrl + '/A'+user_id+'/' + this.artistUrl + '?share=true';
          // changing the url for share url purpose
          this.shareUrl = new Globals().shareUrl + '/artist/' + this.artistUrl + '.html';
          this.shareUrl2 = "<" + "iframe " + "style" + "=" + '"position: relative; width: 100%; min-height: 450px;height:100vh"' +   " src" + "=" + '"' + this.iframeUrl + '"' + ">" +  " </iframe>";
        } else if (this.songUrl) {
            // changing the iframe url to url.com/S/0/song-slug
            this.iframeUrl = new Globals().shareUrl + '/S'+user_id+'/' + this.songUrl + '?share=true';
            // changing the url for share url purpose
            this.shareUrl = new Globals().shareUrl + '/songs/' + this.songUrl + '.html';
            this.shareUrl2 = "<" + "iframe " + "style" + "=" + '"position: relative; width: 100%; min-height: 190px;height:100vh"' +   " src" + "=" + '"' + this.iframeUrl + '"' + ">" +  " </iframe>";
        } else if (this.radioUrl) {
            this.iframeUrl = new Globals().shareUrl + '/R/' + this.radioUrl + '?share=true';
            // changing the url for share url purpose
            this.shareUrl = new Globals().shareUrl + '/playlist/' + this.radioUrl + '.html';
            this.shareUrl2 = "<" + "iframe " + "style" + "=" + '"position: relative; width: 100%; min-height: 450px;height:100vh"'  +  " src" + "=" + '"' + this.iframeUrl + '"' + ">" +  " </iframe>";
        }
        else
          this.shareUrl = new Globals().shareUrl + '/signup/referral_code/' + code;
        // this.shareUrl2 = "<" + "iframe " + "width" + "=" + '"320"' + " height" + "="  + '"460"' +  " src" + "=" + '"' + this.shareUrl + '"' + ">" +  " </iframe>";
      });
    }
  }

  openDialog() {
    window.open(this.shareUrl);
  }

  copyUrl(shareUrl) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = shareUrl;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

}



// WEBPACK FOOTER //
// ./src/app/invite-friends/invite-friends.component.ts